import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CotizadorComponent } from './pages/cotizador/cotizador.component';
import { LoaderComponent } from './pages/new-loader/new-loader.component';
import { NewFinFlujoComponent } from './pages/new-fin-flujo/new-fin-flujo.component';
import { NewPlanesSegurosComponent } from './pages/new-planes-seguros/new-planes-seguros.component';
import { NewArmarPlanComponent } from './pages/new-armar-plan/new-armar-plan.component';
import { NewDatosPropietarioComponent } from './pages/new-datos-propietario/new-datos-propietario.component';
import { NewInmuebleComponent } from './pages/new-inmueble/new-inmueble.component';
import { NewDatosInquilinoComponent } from './pages/new-datos-inquilino/new-datos-inquilino.component';
import { NewDatosInquilinoProcesoComponent } from './pages/new-datos-inquilino-proceso/new-datos-inquilino-proceso.component';
import { CotizacionPausaComponent } from './pages/fin-flujo/cotizacion-pausa/cotizacion-pausa.component';
import { OtroProductoComponent } from './pages/fin-flujo/otro-producto/otro-producto.component';
import { ProblemasTecnicosComponent } from './pages/fin-flujo/problemas-tecnicos/problemas-tecnicos.component';
import { LoSentimosComponent } from './pages/fin-flujo/lo-sentimos/lo-sentimos.component';
import { NoCumplePoliticasComponent } from './pages/fin-flujo/no-cumple-politicas/no-cumple-politicas.component';
import { PolizaActivaComponent } from './pages/fin-flujo/poliza-activa/poliza-activa.component';
import { TenemosTusDatosComponent } from './pages/fin-flujo/tenemos-tus-datos/tenemos-tus-datos.component';
import { AquiEstaremosComponent } from './pages/fin-flujo/aqui-estaremos/aqui-estaremos.component';
import { ValidacionErrorComponent } from './pages/fin-flujo/validacion-error/validacion-error.component';
import { CUMULO } from '@app/routes.constants';
import { CumuloComponent } from '@app/components/FinFlujo/cumulo/cumulo.component';
import { CotizacionPausaInactivoComponent } from './pages/fin-flujo/cotizacion-pausa-inactivo/cotizacion-pausa-inactivo.component';
import { leadResumeGuard } from '@app/guards/lead-resume.guard';
import { RetomaDuplicadoComponent } from './pages/fin-flujo/retoma-duplicado/retoma-duplicado.component';
import { CheckTheInformationComponent } from './pages/fin-flujo/check-the-information/check-the-information.component';
import { SarlaftDeniedComponent } from './pages/fin-flujo/sarlaft-denied/sarlaft-denied.component';
import { ResumenCompraP2PComponent } from './pages/pago/resumen-compra-p2p/resumen-compra-p2p.component';
import { ProcesandoPagoComponent } from './pages/pago/procesando-pago/procesando-pago.component';
import { PagoAprobadoComponent } from './pages/pago/pago-aprobado/pago-aprobado.component';
import { PagoAprobadoNoApComponent } from './pages/pago/pago-aprobado-no-ap/pago-aprobado-no-ap.component';
import { PagoRechazadoP2PComponent } from './pages/pago/pago-rechazado-p2p/pago-rechazado-p2p.component';

const routes: Routes = [
  { path: 'seguros/hogar/arriendo/cotizador', component: CotizadorComponent, canActivate: [leadResumeGuard] },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador', pathMatch: 'full' },
  {
    path: 'seguros/hogar/arriendo/cotizador/loader',
    component: LoaderComponent,
  },
  { 
    path: '', 
    redirectTo: '/seguros/hogar/arriendo/cotizador/loader', 
    pathMatch: 'full' 
  },
  { path: 'seguros/hogar/arriendo/cotizador/finflujo', component: NewFinFlujoComponent },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador/finflujo', pathMatch: 'full' },
  { path: 'seguros/hogar/arriendo/cotizador/planes', component: NewPlanesSegurosComponent, canActivate: [leadResumeGuard] },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador/planes', pathMatch: 'full' },
  {
    path: 'seguros/hogar/arriendo/cotizador/armar-plan',
    component: NewArmarPlanComponent,
    canActivate: [leadResumeGuard],
  },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador/armar-plan', pathMatch: 'full' },
  {
    path: 'seguros/hogar/arriendo/cotizador/datos-propietario',
    component: NewDatosPropietarioComponent,
    canActivate: [leadResumeGuard],
  },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador/datos-propietario', pathMatch: 'full' },
  {
    path: 'seguros/hogar/arriendo/cotizador/datos-inquilino',
    component: NewDatosInquilinoComponent,
    canActivate: [leadResumeGuard],
  },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador/datos-inquilino', pathMatch: 'full' },
  { path: 'seguros/hogar/arriendo/cotizador/compartir-link-inquilino', component: NewDatosInquilinoProcesoComponent },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador/compartir-link-inquilino', pathMatch: 'full' },
  {
    path: 'seguros/hogar/arriendo/cotizador/datos-inmueble',
    component: NewInmuebleComponent,
    canActivate: [leadResumeGuard],
  },
  { path: 'seguros/hogar/arriendo/cotizador/cotizacion-pausa', component: CotizacionPausaComponent },
  { path: 'seguros/hogar/arriendo/cotizador/otro-producto', component: OtroProductoComponent },
  { path: 'seguros/hogar/arriendo/cotizador/problemas-tecnicos', component: ProblemasTecnicosComponent },
  { path: 'seguros/hogar/arriendo/cotizador/lo-sentimos', component: LoSentimosComponent },
  { path: 'seguros/hogar/arriendo/cotizador/no-cumple-politicas', component: NoCumplePoliticasComponent },
  { path: 'seguros/hogar/arriendo/cotizador/poliza-activa', component: PolizaActivaComponent },
  { path: 'seguros/hogar/arriendo/cotizador/tenemos-tus-datos', component: TenemosTusDatosComponent },
  { path: 'seguros/hogar/arriendo/cotizador/aqui-estaremos', component: AquiEstaremosComponent },
  { path: 'seguros/hogar/arriendo/cotizador/inactividad', component: CotizacionPausaInactivoComponent },
  { path: 'seguros/hogar/arriendo/cotizador/validacion-error', component: ValidacionErrorComponent },
  { path: 'seguros/hogar/arriendo/cotizador/retoma', component: RetomaDuplicadoComponent },
  { path: 'seguros/hogar/arriendo/cotizador/check-the-information', component: CheckTheInformationComponent },
  { path: 'seguros/hogar/arriendo/cotizador/sarlaft-denied', component: SarlaftDeniedComponent },
  // Pasarela de pago Place to Pay (Lightbox)
  { path: 'seguros/hogar/arriendo/cotizador/resumen-compra-p2p', component: ResumenCompraP2PComponent },
  { path: 'seguros/hogar/arriendo/cotizador/procesando-pago', component: ProcesandoPagoComponent },
  { path: 'seguros/hogar/arriendo/cotizador/pago-aprobado', component: PagoAprobadoComponent },
  { path: 'seguros/hogar/arriendo/cotizador/pago-aprobado-no-ap', component: PagoAprobadoNoApComponent },
  { path: 'seguros/hogar/arriendo/cotizador/pago-rechazado-p2p', component: PagoRechazadoP2PComponent },
  { path: CUMULO, component: CumuloComponent },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador/datos-inmueble', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forChild(routes)], // Usamos forChild para rutas de módulos hijos
  exports: [RouterModule],
})
export class NewFlowRoutingModule { }
